// src/apiService.js
import axios from 'axios';
import API_BASE_URL from './apiConfig';

const api: any = new Proxy({}, {
  get(target, prop) {
    const headers: any = {
      'Content-Type': 'application/json',
    };
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Create a new Axios instance with the updated headers
    const axiosInstance: any = axios.create({
      baseURL: API_BASE_URL,
      headers: headers,
    });

    // Return the method from the Axios instance (e.g., post, get, etc.)
    return axiosInstance[prop].bind(axiosInstance);
  }
});

// Function to handle company creation
export const createCompany = async (data: any) => {
  try {
    const response = await api.post('/companies', data);
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const getCompanys = async () => {
  try {
    const response = await api.get('/companies');
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const getCompany = async (id: string) => {
  try {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting company:', error);
    throw error;
  }
};

export const updateCompany = async (data: any) => {
  try {
    const response = await api.put(`/companies/${data.id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating company:', error);
    throw error;
  }
};

export const getCurrentCompany = async () => {
  try {
    const response = await api.get('/companies/me');
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const getCurrentCompanyUsers = async () => {
  try {
    const response = await api.get('/companies/me/users');
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const uploadContract = async (data: any) => {
  try {
    const {name, file, companyId, onUploadProgress} = data;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', name);

    const response = await axios.post(`/companies/${companyId}/contracts`, formData, {
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      onUploadProgress,
    });

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const getContracts = async (companyId: string) => {
  try {
    console.log("GET CONTRACTS", companyId)
    const response = await api.get(`/companies/${companyId}/contracts`);
    return response.data;
  } catch (error) {
    console.error('Error getting contracts:', error);
    throw error;
  }
}

export const updateContract = async (data: any) => {
  try {
    const response = await api.put(`/companies/${data.parent}/contracts/${data.id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
}

export const createOrUpdateSubscription = async (planId: string) => {
  try {
    const response = await api.post('/companies/me/subscription', { planId });
    return response.data;
  } catch (error) {
    console.error('Error creating/updating subscription:', error);
    throw error;
  }
};

export const cancelSubscription = async () => {
  try {
    const response = await api.delete('/companies/me/subscription');
    return response.data;
  } catch (error) {
    console.error('Error cancelling subscription:', error);
    throw error;
  }
};

export const deleteContract = async (data: any) => {
  try {
    const {companyId, id} = data;

    const response = await api.delete(`/projects/${companyId}/contracts/${id}`);

    return response.data;
    
  } catch (error) {
    console.error('Error deleting contract:', error);
    throw error;
  }
}

export const uploadLogo = async (data: any) => {
  try {
    const {file, onUploadProgress} = data;
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/companies/me/logo`, formData, {
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      onUploadProgress,
    });

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const getLogo = async () => {
  try {
    const response = await api.get(`/companies/me/logo`);
    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const createSetupIntent = async () => {
  try {
    const response = await api.post('/companies/me/setupIntent' );
    return response.data;
  } catch (error) {
    console.error('Error adding setup method:', error);
    throw error;
  }
}

export const getPaymentMethods = async () => {
  try {
    const response = await api.get('/companies/me/paymentMethods' );
    return response.data;
  } catch (error) {
    console.error('Error adding setup method:', error);
    throw error;
  }
};

export const getInvoices = async () => {
  try {
    const response = await api.get('/companies/me/invoices' );
    return response.data;
  } catch (error) {
    console.error('Error adding setup method:', error);
    throw error;
  }
};

export const getCurrentInvoices = async () => {
  try {
    const response = await api.get('/companies/me/invoices/current' );
    return response.data;
  } catch (error) {
    console.error('Error adding setup method:', error);
    throw error;
  }
};